<template>
  <b-col xs="12" sm="12" md="12" lg="12" xl="12">
    <b-card
      class="shadow-none border-radius-10 eliminate-category mb-2"
      :title="title"
    >
      <div class="rec-cat">
        <b-button
          type="button"
          size="sm"
          @click="$emit('event', title)"
          class="btn-green"
          >Restore</b-button
        >
      </div>
      <div class="clr-box-btns d-flex align-items-center mt-3">
        <div class="category-titles-amount-outer w-100">
          <!-- <span class="category-titles-amount your-amount-value d-block">
            $ 0
          </span> -->
          <span
            class="clr-bx-btn text-white text-center py-1 px-1 your-amount"
            style="width: 5%; background-color: #8ab200"
          >
            $ 0
          </span>
        </div>
        <div class="category-titles-amount-outer w-100">
          <!-- <span class="category-titles-amount your-amount-value d-block">
            $ {{ value1 }}
          </span> -->
          <span
            class="clr-bx-btn text-white text-center py-1 px-1 peers-amount"
            style="width: 90%; background-color: #16cfbc"
          >
            $ {{ value1 }}
          </span>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
export default {
  name: "eliminate-component",
  props: {
    title: String,
    value1: Number,
    value2: Number,
    frequencyOptions: Array,
  },
  data() {
    return {
      isHidden: true,
      fixAmount: null,
      frequency: 12,
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  watch: {},
  methods: {
    percantageCal(arg) {
      //   if(!!this.fixAmount){
      //     const fixAmount = parseInt(this.unmaskMoneyValue(this.fixAmount))
      //     const total = this.value1+fixAmount

      //     if(typeof arg === 'string')
      //         return (fixAmount/total)*100
      //     else
      //         return (arg/total)*100
      //   } else {
      const total = this.value1 + this.value2;
      return (arg / total) * 100;
      //   }
    },
    unmaskMoneyValue(val) {
      return val.replace("$", "").replace(",", "");
    },
  },
};
</script>
